
































import { Vue, Component, Prop } from "vue-property-decorator";
import UIkit from "uikit";
import { SalesRegions } from "@/models/map/region_type";

@Component
export default class Search extends Vue {
  @Prop() label!: string;
  @Prop() region!: SalesRegions;
  protected searchTerm = "";

  mounted() {
    if (this.$route.query.search) {
      this.searchTerm = this.$route.query.search as string;
      this.handleSearch();
      UIkit.dropdown(this.$refs.search).show();
    }
  }

  public handleSearch(): void {
    this.$emit("search", this.searchTerm);
    this.addQToLocation();

  }

  public addQToLocation(): void {
    let url = this.$route.path
    let loop = 0;
    if (this.region) {
      loop++;
      url += "?region=" + this.region;
    }
    if (this.searchTerm) {
      const char = loop > 0 ? '&' : '?'
      url += char + 'search=' + encodeURIComponent(this.searchTerm)
    }
  history.pushState(
    {},
    '',
    url
  )
}

  public close(): void {
    UIkit.dropdown(this.$refs.search).hide(false);
    this.searchTerm = "";
    this.handleSearch();
  }
}
